import Modal from './Modal'
import Input from './Input'
import SelectInput from './SelectInput'
import { useTranslation } from 'react-i18next'
import { GetTodos, GetUsers } from '../graphql/queries'
import { useApolloClient, useMutation, useQuery } from '@apollo/client'
import { CreateTodo, RemoveTodo, UpdateTodo } from '../graphql/mutations'
import { useEffect, useState } from 'react'
import Button from './Button'
import Textarea from './Textarea'
import { TodoStatuses } from '../util/const'
import DateInput from './DateInput'
import ConfirmModal from './ConfirmModal'

const UpdateTodoModal = ({
    show,
    close,
    data,
}) => {
    const { t } = useTranslation()
    const { data: usersData } = useQuery(GetUsers)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const users = usersData?.getUsers?.map((user) => ({
        value: user.ID,
        label: user.RNAME,
    })) || []

    const apolloClient = useApolloClient()

    const [updateTodo, { loading }] = useMutation(UpdateTodo)
    const [deleteTodo, { loading: deleteLoading }] = useMutation(RemoveTodo)

    const [fields, setFields] = useState({
        TITLE: '',
        DESCRIPTION: '',
        DUE_DATE: '',
        STATUS: '',
        ASSIGNEE_ID: '',
    })

    useEffect(() => {
        setFields({
            ...fields,
            ...data,
        })
    }, [data, show])

    const setField = (field, value) => {
        setFields({
            ...fields,
            [field]: value,
        })
    }

    const handleUpdate = async () => {
        try {
            const { data: updateTodoData } = await updateTodo({
                variables: {
                    id: parseInt(data?.ID),
                    data: {
                        TITLE: fields?.TITLE,
                        DESCRIPTION: fields?.DESCRIPTION,
                        DUE_DATE: fields?.DUE_DATE,
                        ASSIGNEE_ID: fields?.ASSIGNEE_ID ? parseInt(fields?.ASSIGNEE_ID) : undefined,
                        STATUS: fields?.STATUS ? parseInt(fields?.STATUS) : undefined,
                    },
                },
            })

            if (updateTodoData?.updateTodo !== 'Success') {
                throw new Error('Failed to update todo')
            }

            apolloClient.refetchQueries({
                include: [GetTodos],
            })
            close()
        } catch (err) {
            console.log('handleAdd error', err)
        }
    }

    const handleDelete = async () => {
        try {
            const { data: deleteTodoData } = await deleteTodo({
                variables: {
                    id: parseInt(data?.ID),
                },
            })

            setShowDeleteModal(false)

            if (deleteTodoData?.removeTodo !== 'Success') {
                throw new Error('Failed to delete todo')
            }

            apolloClient.refetchQueries({
                include: [GetTodos],
            })
            close()
        }
        catch (err) {
            console.log('handleDelete error', err)
        }
    }

    return (
        <>
            <Modal
                show={show}
                close={close}
                title={t('Lisa uus ülesanne')}
            >
                <div className='add-todo-modal-content'>
                    <Input
                        label={t('Pealkiri')}
                        value={fields.TITLE}
                        onChange={(e) => setField('TITLE', e.target.value)}
                    />
                    <Textarea
                        label={t('Kirjeldus')}
                        value={fields.DESCRIPTION}
                        onChange={(e) => setField('DESCRIPTION', e.target.value)}
                    />
                    <DateInput
                        label={t('Tähtaeg')}
                        value={fields.DUE_DATE ? new Date(fields.DUE_DATE) : null}
                        onChange={(val) => {
                            const localeString = val.toLocaleString('en')
                            setField('DUE_DATE', localeString)
                        }}
                    />
                    <SelectInput
                        label={t('Staatus')}
                        value={TodoStatuses.find((status) => status.value === fields.STATUS)}
                        options={TodoStatuses}
                        onChange={(option) => setField('STATUS', option.value)}
                    />
                    <SelectInput
                        label={t('Vastutav')}
                        value={users?.getUsers?.find((user) => user.ID === fields.ASSIGNEE_ID)}
                        options={users}
                        onChange={(option) => setField('ASSIGNEE_ID', option.value)}
                    />
                    <div className='add-todo-modal-actions'>
                        <Button
                            label={t('Kustuta')}
                            onClick={() => setShowDeleteModal(true)}
                            loading={deleteLoading}
                            disabled={deleteLoading}
                            className={'btn-cancel'}
                        />
                        <Button
                            label={t('Salvesta')}
                            onClick={handleUpdate}
                            loading={loading}
                            disabled={loading}
                        />
                    </div>
                </div>
            </Modal>
            <ConfirmModal
                show={showDeleteModal}
                close={() => setShowDeleteModal(false)}
                title={t('Kustuta ülesanne')}
                confirmLabel={t('Kustuta')}
                cancelLabel={t('Katkesta')}
                onConfirm={handleDelete}
            />
        </>
    )
}

export default UpdateTodoModal